<!--
<doc lang="markdown">
</doc>


<style scoped lang="scss">
</style>


<template lang="pug">
</template>
-->

<script>
  // "Herança" direta, mantendo a estrutura isolada (arquivos)
  import LabelField from '../desktop/label-field.vue'
  export default LabelField
</script>
